export default $axios => ({
  countAd(payload, partnerUser, params = {}) {
    return $axios.post(`/api/partnerUser/${partnerUser}/event`, payload, {
      params
    });
  }
});
